import React from 'react';
import { History } from 'fragments';

export const HistoryPage = () => {

  return (
    <History />
  );
};